import { axiosAuthInstance } from '../utils/getSubdomain'
import { limitPagination } from '../utils/Helper'

export const saveTeacherData = (data: FormData) => {
  return axiosAuthInstance.post('/teachers/', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
export const listTeacher = async (
  page: number,
  searchKey?: string | number,
  limitData?: number
) => {
  const limit = limitData ?? limitPagination
  try {
    const params: any = {
      page: page,
      limit: limit,
    }
    if (searchKey) {
      params.search = searchKey
    }
    return await axiosAuthInstance.get(`/teachers/`, { params })
  } catch (error) {
    console.error('Failed to fetch teacher data:', error)
    throw error
  }
}

export const updateTeacherData = (data: FormData, id: string | number) => {
  return axiosAuthInstance.put(`/teachers/${id}/`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const deleteTeacherData = (id: string | number) => {
  return axiosAuthInstance.delete(`/teachers/${id}/`)
}

export const assignSubjectToTeacher = (
  id: string | number,
  subjects_ids: string[]
) => {
  return axiosAuthInstance.post(`/teachers/${id}/assign-subjects`, {
    subjects_ids,
  })
}

export const getAssignedSubject = (id: string | number) => {
  return axiosAuthInstance.get(`/teachers/${id}/subjects`)
}

export const removeAssignedSubject = (
  id: string | number,
  subject_id: string
) => {
  return axiosAuthInstance.delete(
    `/teachers/${id}/remove-subject?subject_id=${subject_id}`
  )
}
export const removeAllAssignedSubject = (
  id: string | number,
  subjects: string[]
) => {
  return axiosAuthInstance.delete(`/teachers/${id}/remove-subjects`, {
    data: subjects,
  })
}
